import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { EnumleaveTimeType } from 'src/app/pages/atestados/models/atestado';
import { EOrdenacao } from 'src/app/shared/data/ordenacao.enum';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { SessionService } from 'src/app/shared/services/session.service';
import { ESolicitacaoConsultaStatus, ISolicitacaoConsultaFiltros, ISolicitaoConsulta } from '../../data/consultas';
import { ConsultasService } from '../../services/consultas.service';

@Component({
  selector: 'app-consultas-list',
  templateUrl: './consultas-list.component.html',
  styleUrls: ['./consultas-list.component.scss']
})
export class ConsultasListComponent implements OnInit {
  ERoleAdminString = ERoleAdminString;
  ordenarControl = new UntypedFormControl(EOrdenacao.MaisNovos);
  acaoInput = new UntypedFormControl();
  opcoesOrdenacao = [
    {
      value: EOrdenacao.AlfabeticaAZ,
      label: 'Alfabética - de A a Z'
    },
    {
      value: EOrdenacao.AlfabeticaZA,
      label: 'Alfabética - de Z a A'
    },
    {
      value: EOrdenacao.MaisNovos,
      label: 'Mais novos'
    },
    {
      value: EOrdenacao.MaisAntigos,
      label: 'Mais antigos'
    }
  ];

  consultas: ISolicitaoConsulta[] = [];
  EnumLeaveType = EnumleaveTimeType;
  ESolicitacaoConsultaStatus = ESolicitacaoConsultaStatus;

  dadosPaginacao = {
    ordenacao: EOrdenacao.MaisNovos,
    paginaSelecionada: 0,
    tamanhoPagina: 10,
    totalPaginas: 0,
    itensTotal: 0,
    periodStart: 0,
    periodEnd: 0
  };

  constructor(private readonly consultasService: ConsultasService, private readonly sessionService: SessionService) {}
  ngOnInit(): void {
    this.carregarConsultas();

    this.ordenarControl.valueChanges.subscribe((ordenacaoSelecionada: EOrdenacao) => {
      this.dadosPaginacao.ordenacao = ordenacaoSelecionada;
      this.carregarConsultas();
    });
  }

  filtrar(): void {
    this.carregarConsultas();
  }

  limparFiltros(): void {
    this.acaoInput.reset();
    this.carregarConsultas();
  }

  carregarConsultas(): void {
    const filtros: ISolicitacaoConsultaFiltros = {
      orderBy: Number(this.dadosPaginacao.ordenacao),
      pageNumber: Number(this.dadosPaginacao.paginaSelecionada),
      pageSize: Number(this.dadosPaginacao.tamanhoPagina),
      periodStart: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
      periodEnd: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1).toISOString(),
      status: Number(this.ESolicitacaoConsultaStatus.pendenteAprovacao)
    };

    const partnerId = this.sessionService.getSession().partnerId;
    const companyId = this.sessionService.getSession().companyId;
    const accountRole = this.sessionService.getSession().accountRole;

    if (partnerId) {
      filtros.partnerId = partnerId;
    }

    if (companyId) {
      filtros.companyId = companyId;
    }

    if (accountRole) {
      filtros.accountRole = parseInt(accountRole);
    }

    if (this.acaoInput.value) {
      filtros.searchText = String(this.acaoInput.value);
    }

    // if(this.sessionService.getSession().role === ERoleAdminString.Doctor){
    //   filtros.doctorId = this.sessionService.getSession()!.sid!;
    // }

    this.consultasService.listarTodasSolicitacoesConsultas(filtros).subscribe((res) => {
      this.consultas = res.data;
      this.dadosPaginacao.totalPaginas = Math.ceil(res.count! / this.dadosPaginacao.tamanhoPagina);
      this.dadosPaginacao.itensTotal = res.count!;
    });
  }

  public mudouPagina(paginaSelecionada: number): void {
    this.dadosPaginacao.paginaSelecionada = paginaSelecionada;

    this.carregarConsultas();
  }

  public mudouTamanhoPagina(itensPaginaSelecionada: number): void {
    this.dadosPaginacao.tamanhoPagina = itensPaginaSelecionada;
    this.dadosPaginacao.paginaSelecionada = 0;

    this.carregarConsultas();
  }
}
